const feature = {
  NONE: 'NONE',
  TSP: 'TSP',
  TSP_PQC: 'TSP_PQC',
  DSS: 'DSS',
  OCSP: 'OCSP',
  MOBILSIGN: 'MOBILSIGN'
}

export default feature
